<template>
    <div>
      <div class="admin_title">报表预览</div>
      <iframe v-if="contents" :src="contents" frameborder="0" style="width: 100%; min-height: 650px;"></iframe>
      <div v-else class="none_ts">
        <img src="@/assets/images/none_data.jpg" alt="">
        <h4>请从左侧“报表预览”菜单下选择一个报表</h4>
      </div>
    </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import utils from '@/utils'
  export default {
    data () {
      return {
        contents: ''
      }
    },
    mounted () {
      this.$on('fr-login-success', (r) => {
        this.contents = config.fineReportPath + '?reportlet=' + utils.getQueryString('reportlet')
      })
    },
    watch: {
      $route (to, from) {
        if (!(!!$('#fr-iframe').length && !!$('#fr-success-iframe').length)) { // 没有登录
          // this.getReport(utils.getQueryString('reportlet'))
          this.fineLogin()
        } else { // 已登录
          this.contents = config.fineReportPath + '?reportlet=' + utils.getQueryString('reportlet')
        }
      }
    },
    destroyed () {
      this.fineLogout()
    },
    methods: {
      getReport (r) {
        var that = this
        api.get(config.bylApiPath, '/fineReport/getFineReportSign', {report: r}, function (r) { // 正常
          that.contents = r.data
        })
      },
      fineLogin() {
        var that = this
        if (!(!!$('#fr-iframe').length && !!$('#fr-success-iframe').length)) {
          var username = utils.getQueryString('domain'); //获取输入的用户名
          var password = '123456';  //获取输入的参数
          var scr = document.createElement("iframe"); // 创建iframe
          var scr1 = document.createElement("iframe"); // 创建iframe
          scr.id = 'fr-iframe';
          scr1.id = 'fr-success-iframe';
          scr.src = config.fineReportPath + "?op=fs_load&cmd=login&fr_username=" + username + "&fr_password=" + password +  "&validity=" + -1 + "&callback=callback"
          scr.style.display = 'none';
          scr1.style.display = 'none';
          document.body.appendChild(scr);
          document.body.appendChild(scr1);
          if (scr.attachEvent) {       // 判断是否为ie浏览器
            scr.attachEvent("onload", function () {
              scr1.src  = config.fineReportPath + "?op=fs" // 直接跳转到数据决策系统
              that.$emit('fr-login-success')
            });
          } else {
            scr.onload = function () {
              scr1.src  = config.fineReportPath + "?op=fs" // 直接跳转到数据决策系统
              that.$emit('fr-login-success')
              // window.location.href = "http://218.80.205.234:8079/WebReport/ReportServer?op=fs"
            };
          }
        }
      },
      fineLogout () {
        this.contents = ''
        $('#fr-iframe').remove()
        $('#fr-success-iframe').remove()
        var scrl = document.createElement("iframe"); // 创建iframe
        scrl.id = 'fr-logout-iframe';
        scrl.src = config.fineReportPath + "?op=fs_load&cmd=ssout"
        scrl.style.display = 'none';
        document.body.appendChild(scrl);
        if (scrl.attachEvent) {       // 判断是否为ie浏览器
          scrl.attachEvent("onload", function () {
            $('#fr-logout-iframe').remove()
          });
        } else {
          scrl.onload = function () {
            $('#fr-logout-iframe').remove()
          };
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/byl/org/reports/index.vue